import {FerryService} from "../../../services/ferryService";
import Dictionary from "../../dictionary/dictionary";
import {FerryModel} from "../../../models/ferry";
import Button from "../../../../common/components/shared/button/button";
import {routingAddresses} from "../../../../helpers/routing";
import {NavLink} from "react-router-dom";
import {Api} from "../../../../helpers/api";
import i18n from "../../../../i18n/i18n";
import ReloadButton from "../../../../common/components/shared/reloadButton/reloadButton";
import {SortDirection} from "../../../../common/models/table";

export default class FerriesList extends Dictionary<FerryModel> {
    private sortableElements = ["number", "name", "shipownerName"];
    constructor(props: any) {
        super(props);

        this.canRemove = true;
        this.linkToModify = routingAddresses.dictionaries.ferries.modify;
    }

    public async componentDidMount(){
        this.getData((await FerryService.getAll({
            orderBy: this.state.orderBy,
            sortDirection: this.state.sortDirection
        })));
    }

    public render(): JSX.Element {
        const properties = ["number", "name", "flagStateName", "shipownerName"];

        const headers = properties.map(key => i18n.t("dictionaries.ferries.headers." + key));
        const actions = this.renderActions;

        return (
            <div className="ferries">
                {this.renderRemovePopup(this.confirmRemove.bind(this))}
                {this.renderWrapperContent(headers, properties, "ferries", actions, undefined, this.getHeader(), this.sortableElements, this.sortingAction.bind(this))}
            </div>
        );
    }

    private getHeader() {
        return (
            <div className="actions">
                <NavLink to={routingAddresses.dictionaries.ferries.add} data-testid="add-ferry">
                    <Button type="primary" text={i18n.t("dictionaries.ferries.actions.addFerry.button")}/>
                </NavLink>
                <ReloadButton
                    reloadFunc={this.reload.bind(this)}
                    testId="ferry-list-reload-btn"
                />
            </div>
        );
    }

    private async reload() {
        this.reloadList((await FerryService.getAll({
            orderBy: this.state.orderBy,
            sortDirection: this.state.sortDirection
        })));
    }

    protected async confirmRemove() {
        this.setState({removeItemResponse: undefined, isWaiting: true});

        const response = await FerryService.removeFerry(this.state.selectedElement!.id);

        this.setState({removeItemResponse: response});

        if (Api.isSuccess(response)) {
            await this.getData((await FerryService.getAll({
                orderBy: this.state.orderBy,
                sortDirection: this.state.sortDirection
            })));
            this.setState({selectedElement: undefined, displayRemovePopup: false});
        } else {
            this.setState({errorMessage: i18n.t("dictionaries.ferries.errors.removeErrorSuffix")});
        }
        this.setState({isWaiting: false});
    }

    private async sortingAction(orderBy: string, sortDirection: SortDirection) {
        await this.setState({orderBy, sortDirection});
        await this.reload();
    }
}
